import { Dropdown } from "@Wonder-Cave/ui";
import { IDropdownValue } from "../Dropdown";

interface ISendingNumberDropdownProps {
  value: IDropdownValue | undefined;
  onChange: (newValue: IDropdownValue[] | undefined) => void;
  disabled?: boolean;
  error?: string;
  options: IDropdownValue[];
}

const PreferredAreaCodeDropdown = ({ value, onChange, disabled = false, error, options, ...rest }: ISendingNumberDropdownProps) => {
  return <Dropdown
    label="Area Code (Optional)"
    labelInfo={"Messages will be sent from phone numbers with the selected area code."}
    options={options}
    value={value}
    onChange={onChange}
    disabled={disabled}
    {...rest}
    gray={disabled}
    error={error}
  />;
};

export default PreferredAreaCodeDropdown;